import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromSynchronization from './synchronization.reducer';

export const selectSynchronizationState = createFeatureSelector<fromSynchronization.State>(
  fromSynchronization.synchronizationFeatureKey
);
export const selectConfigs = createSelector(
  selectSynchronizationState,
  s1 => s1.configs
);

export const selectTaskHistories = (id: string) => createSelector(
  selectSynchronizationState,
  (state) => state.taskHistory[id]
);
